<template>

    <v-card
      width="100%"
      height="100%"
      tile
      flat
      class="black--text text-center  pa-0"
      v-if="currentNews !== null"
    >
    <v-card-text class="pa-0">
      <v-row class="ma-0 pa-0">
        <v-col class="" cols="12">
          <p class="text-xs-body-2 text-sm-body-2 text-md-h5 text-lg-h4 text-xl-h3" v-html="currentNews.titleAction"> </p> 

          <v-row justify="center" align="start">
            <v-col cols="12" sm="6" md="5" lg="4" xl="3" class="" >
              
              <div class="title"><v-icon >mdi-calendar</v-icon> {{currentNews.dateaction}}</div>
              <v-row justify="center" align="start">
                <v-col cols="4" class="pa-0">
                    <v-img 
                    :src="`http://api.trcgagarinsky.ru/terminal__tmp/`+currentNews.logoShopAction" 
                    aspect-ratio="1.0" 
                    contain
                    class="mx-a"
                    ></v-img>                  
                </v-col>
              </v-row>

              <div class="title">{{currentNews.nameShopAction}}</div>
            </v-col>
            <v-col cols="12" sm="6" md="5" lg="4" xl="3">
              <v-img :src="`http://api.trcgagarinsky.ru/terminal__tmp/`+currentNews.bannersUrl" aspect-ratio="1.0"></v-img>

            </v-col>

          </v-row>





          <v-row justify="center">
            <v-col cols="12" sm="12" md="10" lg="8" xl="8" class="text-left">
              <div class="body-1" v-html="currentNews.textAction"></div>
            </v-col>
          </v-row>   
          <v-row justify="center" align="start" class="ma-0 pa-0" v-if="currentNews.bigBannersUrl !== ''">
                <v-col cols="12" class="ma-0 pa-0">
                    <img
                    :src="`http://api.trcgagarinsky.ru/terminal__tmp/`+currentNews.bigBannersUrl" 
                    class="mx-a big-news-image"
                    />                
                </v-col>
          </v-row> 

          <v-row justify="center">
            <v-col cols="12" sm="12" md="10" lg="8" xl="8" class="text-left">
              <div class="body-1" v-html="currentNews.fullTextAction"></div>
            </v-col>
          </v-row>           

        </v-col>
      </v-row>
      </v-card-text>
    </v-card>
</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
import router from 'vue-router'
Vue.use(Vuex)

export default {
  name: 'SingleNews',
  data () {
    return {

      fixed: false,
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-linkedin',
        'mdi-instagram'
      ],
      
    }
  },

  metaInfo () {
    if(DEBUG) console.log('metaInfo() this.currentNews :>> ', this.currentNews);
   if(this.currentNews !== null){ 
     return {
      title: "Новость - "+ this.currentNews.titleAction+ " - "
    }
    }
    else{
    return {
        title: "Новость "
    }
    }
  },

     computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },
          currentNews: {
          get () {
            return this.$store.state.news.currentNews;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setCurrentNews', val)
          }
        },
        currBreadcrumb: {
          get () {
            return this.$store.state.breadcrumb.currBreadcrumb;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setBreadcrumb', val)
          }
        },        
        news() {
          
            return this.$store.state.news.news;
          },
        singleNews(){
          let vApp = this;
          if(vApp.$store.state.news.news.length){
          if(DEBUG) console.log('object :', vApp.$route.params.idNews);
          if(DEBUG) console.log('fff :', vApp.$store.state.news.news.find(fnews=>fnews.id === vApp.$route.params.idNews ));
          return vApp.$store.state.news.news.find(fnews=>fnews.id === vApp.$route.params.idNews );
          }
          else{
            return null;
          }
        },
        titleInnert: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
            return this.$store.state.app.titleInner;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setTitleInner', val)
          }
        },
        loadPathData: {
          get () {
            return this.$store.getters.getLoadPathData
          }          
        },         
     }, 
     methods:{
       startSingleNews(idNews){
          let vApp = this;

          if(DEBUG) console.log('idNews :>> ', idNews);
          if(DEBUG) console.log('vApp.currBreadcrumb :>> ', vApp.currBreadcrumb);

          vApp.currentNews = vApp.news.find(fs=>fs.slug==idNews);

        vApp.currBreadcrumb = [
              {
                disabled: false,
                href:"/",
                text: "ГЛАВНАЯ"
              },
              {
                disabled: false,
                href:'/'+vApp.loadPathData.mnuNewsPath,
                text: "Новости"
              },
              {
                disabled: true,
                href:"",
                text: vApp.currentNews.titleAction
              },
        ];
/*         if(vApp.currBreadcrumb.length<3){
              vApp.currBreadcrumb.push({
                disabled: true,
                href:"",
                text: vApp.currentNews.titleAction
                });
        }
        else{
            vApp.currBreadcrumb[2].text = vApp.currentNews.titleAction;
        } 
          
          vApp.$store.dispatch("setBreadcrumb",vApp.currBreadcrumb);*/
          
       },

     },
     mounted(){

    let vApp = this;
    this.$nextTick(function () {
      if(DEBUG) console.log('mounted SingleNews');
      vApp.titleInnert = 'НОВОСТИ';
      vApp.startSingleNews(vApp.$route.params.idNews);
      let scrollEl = document.querySelector('#scrollT');
      scrollEl.scrollTo(0,0);      
    })
     }      
}
</script>

<style scoped>
.big-news-image{
  width: 100%;
}
</style>
